module.exports = __webpack_public_path__ + "static/img/6011_phase_function_Paper_PointsHejduk_Prediction.6861176.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6011_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Qwef
// module chunks = 0